#import '../common/image.gql'

fragment hero on heroDefault_Entry {
  id
  typeHandle
  ckeditorHeading
  ckeditorSimple
  imageSingle {
    ...image
  }
}